import React from 'react';
import { setPropTypes, PropTypes } from 'proper-types';
import { compose, defaultProps, setDisplayName, withProps } from 'recompose';
import omitProps from '@hocs/omit-props';
import View from '@bubble-ui/primitive-view';
import SelectorExpandableOption from '@bubble-contrib/molecule-selector-expandable-option';

var getIds = function getIds(_ref) {
  var id = _ref.id;
  return {
    ids: id ? {
      root: id,
      option: function option(index) {
        return "".concat(id, "__option__").concat(index);
      }
    } : {
      option: function option() {
        return undefined;
      }
    }
  };
};

var SelectorExpandable = function SelectorExpandable(_ref2) {
  var ids = _ref2.ids,
      onChange = _ref2.onChange,
      options = _ref2.options;
  return /*#__PURE__*/React.createElement(View, {
    id: ids.root
  }, options.map(function (_ref3, index) {
    var label = _ref3.label,
        description = _ref3.description,
        expanded = _ref3.expanded;
    return /*#__PURE__*/React.createElement(SelectorExpandableOption, {
      id: ids.option(index),
      key: index,
      label: label,
      description: description,
      expanded: expanded,
      isLast: options.length - 1 === index,
      onClick: function onClick(expanded) {
        return onChange(label, expanded);
      }
    });
  }));
};

export default compose(setDisplayName('SelectorExpandable'), setPropTypes({
  id: PropTypes.string,
  options: PropTypes.array
}), defaultProps({
  onChange: function onChange() {}
}), withProps(getIds), omitProps('id'))(SelectorExpandable);
//# sourceMappingURL=index.js.map